import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost,
  requestDelete as wsRequestDelete
} from "./_wsApiFetchData";

export async function searchSubscription(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const {
    membershipId, userId, status, beforeAt, afterAt, subscriptionId, reference,
    orderBy, orderDirection
  } = filters;

  const params = {
    Page: skipPages || 1,
    Count: resultsCount,
    Reference: reference,
    SubscriptionId: subscriptionId || undefined,
    MembershipId: membershipId || undefined,
    UserId: userId || undefined,
    Status: status || undefined,
    BeforeAt: beforeAt || undefined,
    AfterAt: afterAt || undefined,
    // Both optional. Absent, the endpoint answers what it always has — newest
    // first by creation — so the old admin's request is unchanged.
    OrderBy: orderBy || undefined,
    OrderDirection: orderDirection || undefined
  };

  return toPascal(await wsRequestGet('/admin/subscriptions/search', language, timeZone, params, cancelToken));
}

export async function getSubscription(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/subscriptions/${id}`, language, timeZone, null, cancelToken));
}

export async function cancelSubscription(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestDelete(`/admin/subscriptions/${id}/cancel`, language, timeZone, null, null, cancelToken));
}

export async function suspendSubscription(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestPost(`/admin/subscriptions/${id}/suspend`, language, timeZone, null, null, cancelToken));
}

export async function forceTermination(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestPost(`/admin/subscriptions/${id}/force-termination`, language, timeZone, null, null, cancelToken));
}

export async function resumeSubscription(id, language, timeZone, cancelToken) {
  return toPascal(wsRequestPost(`/admin/subscriptions/${id}/resume`, language, timeZone, null, null, cancelToken));
}

export async function regretSubscription(id, language, timeZone, cancelToken) {
  return toPascal(wsRequestPost(`/admin/subscriptions/${id}/regret`, language, timeZone, null, null, cancelToken));
}

export async function isRegrettable(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/subscriptions/${id}/is-regrettable`, language, timeZone, null, cancelToken));
}

export async function charge(id, language, timeZone, cancelToken) {
  return toPascal(wsRequestGet(`/admin/subscriptions/${id}/charge`, language, timeZone, null, cancelToken));
}

function toPascal(o) {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toPascal(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}
